var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "footer-content", class: _vm.footerClass },
    [
      _c(
        "footer-email-collection",
        { attrs: { schema: _vm.schemaMain } },
        [_vm._t("default")],
        2
      ),
      _c("footer-main", {
        attrs: { schema: _vm.schemaMain, schemaContact: _vm.schemaContact }
      }),
      _c("footer-sub-footer", { attrs: { schema: _vm.schemaSubfooter } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }